import React from 'react';
import { Button, Col, Form, Input, Label, Row } from 'reactstrap';

interface NewHireStepThreeProps {
  handleSubmitForm: (e: React.FormEvent<HTMLFormElement>) => void;
  classroom: string;
  setClassroom: (value: string) => void;
  education: string;
  setEducation: (value: string) => void;
  experienceEce: string;
  setExperienceEce: (value: string) => void;
  goodFitReason: string;
  setGoodFitReason: (value: string) => void;
  setNewEmployeeFormStep: (step: number) => void;
}

const NewHireStepThree: React.FC<NewHireStepThreeProps> = ({
  handleSubmitForm,
  classroom,
  setClassroom,
  education,
  setEducation,
  experienceEce,
  setExperienceEce,
  goodFitReason,
  setGoodFitReason,
  setNewEmployeeFormStep,
}) => {
  return (
    <>
      <h4>Information Needed For Approval</h4>
      <Form onSubmit={handleSubmitForm} className="mt-4">
        <Row className="d-flex align-items-center">
          <Col lg="3">
            <Label className="form-control-label" htmlFor="classroomInput">
              Which Classroom?
            </Label>
          </Col>
          <Col lg="9">
            <Input
              id="classroomInput"
              type="text"
              value={classroom}
              onChange={(e) => setClassroom(e.target.value)}
              placeholder="Type the classroom"
            />
          </Col>
        </Row>

        <Row className="d-flex align-items-center mt-4">
          <Col lg="3">
            <Label className="form-control-label" htmlFor="educationInput">
              Education
            </Label>
          </Col>
          <Col lg="9">
            <Input
              id="educationInput"
              type="text"
              value={education}
              onChange={(e) => setEducation(e.target.value)}
              placeholder="Type the education"
            />
          </Col>
        </Row>

        <Row className="d-flex align-items-center mt-4">
          <Col lg="3">
            <Label className="form-control-label" htmlFor="experienceEceInput">
              Experience in ECE
            </Label>
          </Col>
          <Col lg="9">
            <Input
              id="experienceEceInput"
              type="text"
              value={experienceEce}
              onChange={(e) => setExperienceEce(e.target.value)}
              placeholder="Type the experience in ECE"
            />
          </Col>
        </Row>

        <Row className="d-flex align-items-center mt-4">
          <Col lg="3">
            <Label className="form-control-label" htmlFor="goodFitReasonInput">
              Why do you believe they will be a good fit for your team?
            </Label>
          </Col>
          <Col lg="9">
            <Input
              id="goodFitReasonInput"
              type="textarea"
              rows="3"
              value={goodFitReason}
              onChange={(e) => setGoodFitReason(e.target.value)}
              placeholder="Explain why they will be a good fit for the team"
            />
          </Col>
        </Row>

        <hr />

        <div className="d-flex justify-content-end mt-4">
          <div>
            <Button className="btn-secondary mr-2" onClick={() => setNewEmployeeFormStep(1)}>
              Back
            </Button>
            <Button color="warning" type="submit">
              Continue
            </Button>
          </div>
        </div>
      </Form>
    </>
  );
};

export default NewHireStepThree;
